export class ActionLog {
  action: string;
  actionLogId: number;
  actionIndex: number;
  actionLevel: number;
  actionStatus: number;
  actionTime: string;
  entityName: string;
  entityPath: string;
  entityType: string;
  initiator: string;
  description: string;
  isExpanded: boolean;
}

export interface AddActionLog {
  action: string;
  actionOn: string;
  entityName: string;
  description: string;
  actionLevel: number;
}

export interface ActionLogsDataI {
  totalLogs: number;
  actionLogsData: ActionLog[];
}
export enum ActionLogActionLevel {
  Critical,
  Error,
  Informative,
  Warning,
}
